<template>
    <div>
        <div class="base-search-container pt10 pb10 mb10" style="background-color: #f6f8f9">
            <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="table-layout">
            <el-table ref="tableList" :data="contractList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column width="55" align="center">
                    <template slot-scope="rows">
                        <el-radio v-model="currContractNo" :label="rows.row.no">&nbsp;</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="sndPartyName" label="卖家商户名称" align="left" width="200"></el-table-column>
                <el-table-column prop="no" label="系统合同编号" align="left" width="180"></el-table-column>
                <el-table-column prop="title" label="合同名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="fstPartyHtBh" label="自用合同编号" width="200" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="signDate" label="签署日期" align="center" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="dateEnd" label="结束时间" align="center" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="state" label="状态" width="100" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <el-tag v-if="rows.row.confirmed && rows.row.curValid && !rows.row.fullfilled && !rows.row.closed && rows.row.lockMode != 1" type="success" style="background-color: transparent; border: none" close-transition>
                            <span v-if="rows.row.lockMode == -1">履约中<br/><span class="ml5 font-red">(已变更)</span></span>
                            <span v-else-if="rows.row.lockMode == 0">履约中</span>
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="phaseName" label="计划阶段" align="left" width="100" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>

    </div>

</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import appConf from '../../app.conf';
    import { getDefaultPageSizes } from '../../../src/app.conf'

    import contractApi from '../../api/contract'

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "label": "系统合同编号",
            "code": "no",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "合同名称",
            "code": "title",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "自用合同编号",
            "code": "fstPartyHtBh",
            "basic": true
        }, {
            "type": "Date2",
            "valueType": "String",
            "label": "签署日期",
            "code": "signDate",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "自用合同标签",
            "code": "fstPartyFlag",
            "basic": true
        }, {
            "type": "Date2",
            "valueType": "String",
            "label": "结束日期",
            "code": "dateEnd"
        }, {
            "type": "Num2",
            "valueType": "Float",
            "label": "预计合同金额",
            "code": "estmtAmount"
        }],
        "sortFields": [{
            "label": "签署日期",
            "code": "signDate",
            "order": "desc",
            "enabled": true
        }, {
            "label": "结束日期",
            "code": "dateEnd",
            "order": "desc",
            "enabled": true
        }]
    };

    export default {
        name: 'swb-contract-list-for-select',
        desc: '合同选择(单选)',
        props: {
            no: {
                type: String,
                default: null,
            },
            params: {
                type: Object,
                default: null,
            },
        },
        data: function () {
            return {
                contractList: [],
                contractType: null,
                fstPartyFlag: null,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                totalCount: 0,
                selectedContract: null,
                currContractNo: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                }
            }
        },
        created: function () {
            this.queryConfig = searchConfigData || {};
            this.currContractNo = this.no || null;
            //
            if(!Utils.isNoB(this.params)) {
                this.queryModel.filterItems = this.params;
            }
            //
            this.pageSize = this.pageSizes.first();
            this.getContractList();
            //
        },
        methods: {
            handleCurrentChange: function (val) {
                if(val != null) {
                    this.selectedContract = val;
                    this.currContractNo = val.no;
                }
            },
            queryHandler: function (queryModel) {
                this.queryModel = Utils.merge(this.queryModel, queryModel);
                this.pageNumber = 1;
                this.getContractList();
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getContractList();
            },
            getContractList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = this.queryModel.filterItems;
                postData.filterItems = Utils.merge({}, filterItems);
                let msgBoxDlg = MsgBox.loading();
                contractApi.getContractList(postData, function (result) {
                    msgBoxDlg.close();
                    let resultData = result.data;
                    //
                    let pagination = resultData.pagination;
                    self.totalCount = pagination.totalCount;
                    self.pageNumber = pagination.pageNumber;
                    self.pageSize = pagination.pageSize;
                    //
                    self.contractList = resultData.rows;
                });
            },
            getDlgResult: function () {
                let result = {};
                let contract = this.selectedContract;
                if(Utils.isNoB(contract) || contract.id == null) {
                    result.type = "warn";
                    result.message = "请选择合同";
                } else {
                    result.type = "info";
                    result.data = contract;
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractListForSelect.vue